<template>
  <div v-if="shipping_list.length">
    <br>
    <div class="Item-Row">
      <div>
      <label>{{ $t('checkout.shipping') }}</label> &nbsp;
      <select v-model="selected">
        <option v-for="shipping in localData" :value="shipping">{{ shipping.name }}</option>
      </select>
      </div>

      <span v-show="selected_shipping.price">{{ selected.price | formatCurrency(active_module.currency)}}</span>
    </div>
    <div class="Item-Row" v-show="selected_shipping.price">

            <h4>{{ $t('checkout.total')}}</h4>

    <p class="price-bold">{{ totalWithShipping | formatCurrency(active_module.currency) }}</p>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    props: ['total'],

    data () {
      return {
        localData: null,
        error: null,
        loading: false
      };
    },

    computed: {
      ...mapState({
        active_module: state => state.Module.active_module,
        selected_shipping: state => state.Cart.selected_shipping,
        shipping_list: state => state.Cart.shipping_list
      }),
      selected: {
        get () {
          return this.selected_shipping;
        },

        set (val) {
          this.set_shipping(val);
        }
      },

      totalWithShipping () {
        return parseFloat((parseFloat(this.total) + parseFloat(this.selected.price)).toFixed(2));
      }
    },

    methods: {
      ...mapActions([
        'init_shipping',
        'set_shipping'
      ]),

      fetchData () {
        this.localData = this.error = null;
        this.loading = true;

        this.init_shipping({
          module_id: this.$route.params.module_id
        }).then((resp) => {
          this.loading = false;
          this.localData = {...this.shipping_list};
        }).catch((error) => {
          this.loading = false;
          this.error = error;
        });
      }

    },

    created () {
      this.fetchData();
    },

    watch: {
      'route': 'fetchData'
    }
  };
</script>

<style scoped>
  .price-bold {
    font-size: 30px;
    font-weight: 400;
    color: #B6CD77;
  }

 .Item-Row {
  display: flex;
    align-items: center;
    justify-content: space-between;
 }
</style>



// WEBPACK FOOTER //
// Shipping.vue?3b108914